import type { ReactNode } from "react";
import { cloneElement, Fragment, isValidElement } from "react";
import type { ButtonSize } from "./types";

type Props = {
  icon: ReactNode;
  size?: ButtonSize;
};

type IconProps = {
  size?: number | string;
  width?: number | string;
  height?: number | string;
};

export const ButtonIcon = ({ icon, size = "sm" }: Props) => {
  const iconSizeMap: Record<ButtonSize, number> = {
    xs: 12,
    sm: 16,
    md: 20,
    lg: 20,
  };

  if (icon == null || icon === false) return null;

  if (!isValidElement<IconProps>(icon)) return <>{icon}</>;

  if (icon.type === Fragment) return icon;

  const { size: ownSize, width, height } = icon.props ?? {};
  if (ownSize != null || width != null || height != null) return icon;

  const target = iconSizeMap[size];

  if (typeof icon.type === "string" && icon.type === "svg") {
    return cloneElement(icon, { width: target, height: target });
  }

  return cloneElement(icon, { size: target });
};
